/**
 * OT
 *
 * Our initialising function for the OT Common application
 *
 * @return {function}
 */

OT.createNS('OT.Common.init');

OT.Common.init = function() {
    'use strict';

    OT.Common.LazyLoadImages.init();

    var scrolling = false;
    var scrollingTO;
    var lastScrollTop = OT.Common.EnvInfo().Window.scrollTop;


    $(window).on('scroll', function() {
        OT.Events.fire('scroll');

        if (!scrolling) {
            scrolling = true;

            scrollingTO = setInterval(function() {
                if (lastScrollTop === OT.Common.EnvInfo().Window.scrollTop) {
                    OT.Events.fire('scroll:stop');
                    scrolling = false;
                    clearInterval(scrollingTO);
                }

                lastScrollTop = OT.Common.EnvInfo().Window.scrollTop;
            }, 100);
        }
    });

    if (_) {
        $(window).on('scroll', _.throttle(function () {
            OT.Events.fire('scroll:throttled');
        }, 250));
    }

    if (OT.Common.Config.get('EnablePageLoadLogging')) {
        $(window).load(function() {
            setTimeout(function() {
                OT.Common.sendLogRequest('SearchResults_PageLoad', {
                    BrowserInfo: OT.Common.Helpers.buildBrowserProfile(),
                    PerfInfo: OT.Common.Helpers.buildPerformanceProfile(),
                    searchParams: OT.Search.Params.getAll(),
                    Experiments: OT.Search.Data.get().Experiments
                });
            }, 2000);
        });
    }

    $(function() {
        $('.js-ellipsis').dotdotdot({
            after: "a.ellipsis-showmore",
            callback: dotdotdotCallback
        });

        $(".js-ellipsis").on('click', 'a', function () {
            var $parentDiv = $(this).closest(".js-ellipsis");
            if ($(this).hasClass("ellipsis-showmore")) {
                $parentDiv.trigger('destroy').toggleClass('collapsed expanded');
            } else {
                $parentDiv.toggleClass('collapsed expanded').dotdotdot({
                    after: "a.ellipsis-showmore",
                    callback: dotdotdotCallback
                });
            }
        });

        function dotdotdotCallback(isTruncated, originalContent) {
            if (isTruncated) {
                $("a.ellipsis-showmore", this).css("display", "inline");
            }
        }
    });
};

